const baseStyles = `
  body { margin: 0; padding: 0; background-color: #faf5f1; font-family: Georgia, 'Times New Roman', serif; color: #444; }
  .container { max-width: 600px; margin: 0 auto; background-color: #ffffff; padding: 40px 32px; }
  .header { text-align: center; border-bottom: 2px solid #DCAE9D; padding-bottom: 24px; margin-bottom: 32px; }
  .header h1 { font-family: Georgia, 'Times New Roman', serif; color: #DCAE9D; font-size: 28px; margin: 0; font-weight: normal; letter-spacing: 1px; }
  .lead { font-size: 16px; line-height: 1.6; color: #555; margin: 0 0 24px 0; }
  .highlight-box { background-color: #fdf6f2; border-left: 4px solid #DCAE9D; padding: 16px 20px; margin: 24px 0; }
  .highlight-box p { margin: 4px 0; font-size: 15px; color: #555; }
  .section-title { font-family: Georgia, serif; color: #DCAE9D; font-size: 20px; margin: 32px 0 16px 0; font-weight: normal; }
  .total-row { text-align: right; font-size: 18px; font-weight: bold; color: #333; margin-top: 16px; padding-top: 16px; border-top: 2px solid #DCAE9D; }
  .footer { margin-top: 40px; padding-top: 24px; border-top: 1px solid #eee; text-align: center; font-size: 13px; color: #999; }
  .gift-card { display: table; width: 100%; margin-bottom: 12px; background-color: #fdf6f2; border: 1px solid #f0e2d8; border-radius: 6px; padding: 12px; box-sizing: border-box; }
  .gift-card-image { display: table-cell; width: 80px; vertical-align: top; }
  .gift-card-image img { width: 72px; height: 72px; object-fit: cover; border-radius: 4px; }
  .gift-card-body { display: table-cell; vertical-align: top; padding-left: 12px; }
  .gift-card-name { font-size: 16px; font-weight: bold; color: #333; margin: 0 0 4px 0; }
  .gift-card-meta { font-size: 14px; color: #777; margin: 0; }
  .custom-message-card { background-color: #fdf6f2; border-left: 4px solid #DCAE9D; padding: 20px 24px; margin: 24px 0; font-style: italic; font-size: 16px; line-height: 1.7; color: #555; border-radius: 4px; }
`;

export const DEFAULT_BUYER_PENDING_HTML = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Recebemos sua escolha</title>
  <style>${baseStyles}</style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>Mari &amp; João</h1>
    </div>
    <p class="lead">Olá, {{fromName}}!</p>
    <p class="lead">Recebemos sua escolha de presente e estamos aguardando a confirmação do pagamento. Assim que o pagamento for processado, você receberá um novo e-mail de confirmação.</p>
    <div class="highlight-box">
      <p><strong>Identificador do pagamento:</strong> {{paymentId}}</p>
      <p><strong>E-mail:</strong> {{email}}</p>
    </div>
    <h2 class="section-title">Seus presentes</h2>
    {{gifts}}
    <div class="total-row">Total: {{totalPrice}}</div>
    <h2 class="section-title">Sua mensagem</h2>
    <p class="lead">{{message}}</p>
    <div class="footer">
      Com carinho,<br />
      Mari &amp; João
    </div>
  </div>
</body>
</html>`;

export const DEFAULT_BUYER_CONFIRMATION_HTML = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Pagamento confirmado</title>
  <style>${baseStyles}</style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>Mari &amp; João</h1>
    </div>
    <p class="lead">Olá, {{fromName}}!</p>
    <p class="lead">Seu pagamento foi confirmado. Muito obrigado pelo carinho e generosidade — significa muito para nós!</p>
    <div class="highlight-box">
      <p><strong>Identificador do pagamento:</strong> {{paymentId}}</p>
      <p><strong>E-mail:</strong> {{email}}</p>
    </div>
    <h2 class="section-title">Presentes confirmados</h2>
    {{gifts}}
    <div class="total-row">Total: {{totalPrice}}</div>
    <h2 class="section-title">Sua mensagem</h2>
    <p class="lead">{{message}}</p>
    <div class="footer">
      Com gratidão,<br />
      Mari &amp; João
    </div>
  </div>
</body>
</html>`;

export const DEFAULT_BRIDES_NOTIFICATION_HTML = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Novo presente recebido</title>
  <style>${baseStyles}</style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>Alguém comprou um presente!</h1>
    </div>
    <p class="lead">Vocês receberam um novo presente na lista de casamento.</p>
    <div class="highlight-box">
      <p><strong>De:</strong> {{fromName}}</p>
      <p><strong>E-mail:</strong> {{email}}</p>
      <p><strong>Identificador do pagamento:</strong> {{paymentId}}</p>
    </div>
    <h2 class="section-title">Presentes</h2>
    {{gifts}}
    <div class="total-row">Total: {{totalPrice}}</div>
    <h2 class="section-title">Mensagem do comprador</h2>
    <p class="lead">{{message}}</p>
    <div class="footer">
      Notificação automática do site de casamento
    </div>
  </div>
</body>
</html>`;

export const DEFAULT_BUYER_REJECTED_HTML = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Não foi possível processar seu pagamento</title>
  <style>${baseStyles}</style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>Mari &amp; João</h1>
    </div>
    <p class="lead">Olá, {{fromName}}!</p>
    <p class="lead">Infelizmente, não foi possível processar seu pagamento. Isso pode acontecer por diversos motivos — saldo insuficiente, dados incorretos do cartão ou recusa do banco emissor.</p>
    <p class="lead">Se desejar, você pode tentar novamente acessando nossa lista de presentes. Estamos à disposição caso precise de ajuda.</p>
    <div class="highlight-box">
      <p><strong>Identificador do pagamento:</strong> {{paymentId}}</p>
      <p><strong>E-mail:</strong> {{email}}</p>
    </div>
    <h2 class="section-title">Presentes selecionados</h2>
    {{gifts}}
    <div class="total-row">Total: {{totalPrice}}</div>
    <h2 class="section-title">Sua mensagem</h2>
    <p class="lead">{{message}}</p>
    <div class="footer">
      Com carinho,<br />
      Mari &amp; João
    </div>
  </div>
</body>
</html>`;

export const DEFAULT_BUYER_THANK_YOU_HTML = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Nosso muito obrigado</title>
  <style>${baseStyles}</style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>Mari &amp; João</h1>
    </div>
    <h2 class="section-title">Mensagem dos noivos</h2>
    <p class="lead">{{customMessage}}</p>
    <div class="highlight-box">
      <p><strong>Identificador do pagamento:</strong> {{paymentId}}</p>
      <p><strong>E-mail:</strong> {{email}}</p>
    </div>
    <h2 class="section-title">Seu presente</h2>
    {{gifts}}
    <div class="total-row">Total: {{totalPrice}}</div>
    <h2 class="section-title">Você escreveu</h2>
    <p class="lead">{{message}}</p>
    <div class="footer">
      Com todo o nosso carinho,<br />
      Mari &amp; João
    </div>
  </div>
</body>
</html>`;

const SAMPLE_GIFTS_HTML = `
  <div class="gift-card">
    <div class="gift-card-image"><img src="https://via.placeholder.com/72x72/DCAE9D/ffffff?text=Presente" alt="Presente" /></div>
    <div class="gift-card-body">
      <p class="gift-card-name">Jogo de Panelas</p>
      <p class="gift-card-meta">R$ 150,00 &times; 1 = R$ 150,00</p>
    </div>
  </div>
  <div class="gift-card">
    <div class="gift-card-image"><img src="https://via.placeholder.com/72x72/DCAE9D/ffffff?text=Presente" alt="Presente" /></div>
    <div class="gift-card-body">
      <p class="gift-card-name">Taças de Cristal</p>
      <p class="gift-card-meta">R$ 50,00 &times; 2 = R$ 100,00</p>
    </div>
  </div>
`;

const SAMPLE_VALUES: Record<string, string> = {
  fromName: 'João Silva',
  email: 'joao.silva@example.com',
  message: 'Parabéns aos noivos! Muita felicidade nessa nova etapa.',
  totalPrice: 'R$ 250,00',
  paymentId: '1234567890',
  gifts: SAMPLE_GIFTS_HTML,
  customMessage:
    'Muito obrigado pelo presente! Vocês fizeram parte de um momento especial das nossas vidas.',
};

export const renderPreview = (html: string): string => {
  return Object.entries(SAMPLE_VALUES).reduce(
    (acc, [key, value]) => acc.replace(new RegExp(`{{\\s*${key}\\s*}}`, 'g'), value),
    html,
  );
};
